import { Link } from "react-router-dom";
import { SERVICE_LIST } from "@/data/services";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 pt-24 pb-12 px-6 md:px-12 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-24">
          <div>
            <h3 className="font-serif text-2xl mb-4">Irina Ishik</h3>
            <p className="font-mono text-[10px] tracking-[0.22em] text-gold uppercase mb-6">Employee Relations &amp; People Risk Advisory</p>
            <p className="text-muted2 text-sm max-w-xs leading-relaxed">
              Independent senior support for complex employee cases, workplace investigations and scalable ER
              frameworks — across Dubai, the UAE and the wider Middle East.
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] text-muted2 uppercase mb-6">Expertise</p>
            {SERVICE_LIST.map((s) => (
              <Link key={s.slug} to={`/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="block text-bone/85 hover:text-gold transition-colors mb-3 text-sm">{s.navLabel}</Link>
            ))}
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] text-muted2 uppercase mb-6">Navigate</p>
            <Link to="/book-consultation" data-testid="footer-book" className="block text-gold hover:text-goldhover transition-colors mb-3 text-sm">Book a Consultation</Link>
            <Link to="/insights" data-testid="footer-insights" className="block text-bone/85 hover:text-gold transition-colors mb-3 text-sm">Insights &amp; Articles</Link>
            <Link to="/markets/uae" data-testid="footer-market-uae" className="block text-bone/85 hover:text-gold transition-colors mb-3 text-sm">UAE</Link>
            <Link to="/markets/europe" data-testid="footer-market-europe" className="block text-bone/85 hover:text-gold transition-colors mb-3 text-sm">Europe</Link>
            <Link to="/markets/turkey" data-testid="footer-market-turkey" className="block text-bone/85 hover:text-gold transition-colors mb-3 text-sm">Turkey</Link>
            <Link to="/login" data-testid="footer-admin" className="block text-muted2 hover:text-gold transition-colors text-xs mt-2">Advisor Login</Link>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] text-muted2 uppercase mb-6">Contact</p>
            <a href="mailto:irina@ishikadvisory.com" data-testid="footer-email" className="block text-bone hover:text-gold transition-colors mb-3 text-sm">irina@ishikadvisory.com</a>
            <a href="mailto:irinaishik@gmail.com" data-testid="footer-email-alt" className="block text-bone hover:text-gold transition-colors mb-3 text-sm">irinaishik@gmail.com</a>
            <a href="tel:+971507736237" data-testid="footer-phone" className="block text-bone hover:text-gold transition-colors mb-3 text-sm">+971 50 773 62 37</a>
            <p className="text-muted2 text-sm">Dubai, United Arab Emirates</p>
          </div>
        </div>

        <div className="text-center">
          <h2 className="font-serif text-[15vw] leading-none text-outline select-none">ISHIK</h2>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-mono text-[10px] tracking-[0.2em] text-muted2 uppercase">© {new Date().getFullYear()} Irina Ishik. All Rights Reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-muted2 uppercase">Independent · Confidential · Senior</p>
        </div>
      </div>
    </footer>
  );
}
